import React from 'react';
import SideBarMobileView from "./components/sideBarMobileView";
import SideBarDesktopView from "./components/sideBarDesktopView";

import { userAuthDetail } from "../../store/atoms/userDetailAtom";
import { useRecoilState, } from "recoil";

import '../../styles/VerifyLoginComponent.css'
import '../../styles/UserSignInComponent.css'
import '../../styles/style.css'

const SidebarComponent = () => {

  const [userAuth, setUserAuth] = useRecoilState(userAuthDetail);
  return (
    <>
        <SideBarMobileView/>
        <SideBarDesktopView/>
    </>
  );
}

export default SidebarComponent;
